import { useState } from 'react';

import { Scope, SortOption } from '@utils/backend-api/search';

const useSearchState = ({
  initialQuery,
  initialPage,
  initialSort,
  initialScope,
}: {
  initialQuery?: string;
  initialPage: number;
  initialSort: SortOption;
  initialScope: Scope;
}) => {
  const [query, setQuery] = useState(initialQuery || '');
  const [page, setPage] = useState(initialPage);
  const [sort, setSort] = useState<SortOption>(initialSort);
  const [scope, setScope] = useState<Scope>(initialScope);

  const updateUrl = (params: Record<string, string | undefined>) => {
    const url = new URL(window.location.href);

    Object.entries(params).forEach(([key, value]) => {
      if (!value) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
    });

    window.history.pushState({}, '', url.toString());
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    updateUrl({ page: newPage.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSortChange = (newSort: SortOption) => {
    setSort(newSort);
    setPage(1);
    updateUrl({ sort: newSort, page: '1' });
  };

  const handleSearchSubmit = (newQuery: string) => {
    setQuery(newQuery);
    setPage(1);
    updateUrl({ query: newQuery, page: '1' });
  };

  const handleClearSearch = () => {
    setQuery('');
    setPage(1);
    setSort(SortOption.Relevant);
    setScope(Scope.Articles);
    updateUrl({
      query: undefined,
      page: undefined,
      sort: undefined,
      scope: undefined,
    });
  };

  const handleScopeChange = (newScope: Scope) => {
    setScope(newScope);
    setPage(1);
    updateUrl({ scope: newScope, page: '1' });
  };

  return {
    handleClearSearch,
    handlePageChange,
    handleScopeChange,
    handleSearchSubmit,
    handleSortChange,
    page,
    query,
    scope,
    setQuery,
    sort,
  };
};

export default useSearchState;
